export default __webpack_public_path__ + "static/media/Corporate_Card.c08fe97f.png";